import { Box, defaultColors, OParagraph } from '@lifechurch/react-ion';
import dayjs from 'dayjs';
import { GetServerSideProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import AnalyticsTabs from '@components/Analytics/AnalyticsTabs';
import { PageHeader } from '@components/PageHeader';
import { useQuery } from '@apollo/client';
import { SERVICES_CONNECTION } from '@lib/queries';
import {
  AdminServicesConnectionQuery,
  AdminServicesConnectionQueryVariables,
  OrderType,
} from '@generated/types';
import { LoadingScreen } from '@components/LoadingScreen';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE } from '@utils/constants';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const Services: NextPage = () => {
  const router = useRouter();
  const { data, loading } = useQuery<
    AdminServicesConnectionQuery,
    AdminServicesConnectionQueryVariables
  >(SERVICES_CONNECTION, {
    fetchPolicy: 'network-only',
    variables: {
      from: dayjs(0).toISOString(),
      to: dayjs(),
      limit: 1,
      order: OrderType.DESC,
      filter: {
        hasContent: true,
      },
    },
  });
  const { t } = useTranslation(['analytics_services', 'common']);

  useEffect(() => {
    if (data?.currentOrganization?.servicesConnection?.services.length) {
      router.push(
        `/analytics/services/${data.currentOrganization.servicesConnection.services[0].id}`
      );
    }
  }, [data, router]);

  return (
    <Box>
      <PageHeader title={t('analytics')} />
      <AnalyticsTabs activeId={'overview'} />
      {loading ? (
        <LoadingScreen />
      ) : (
        <Box data-testid='noServices' display='flex' flexDirection='column' marginTop='48px'>
          <Box margin='0 auto'>
            <img
              alt='Services'
              data-testid='analyticsImage'
              height={200}
              src={`/admin/static/analytics_image.png`}
              width={302}
            />
          </Box>
          <Box margin='0 auto' maxWidth='488px' padding='16px 0 0 0' textAlign='center'>
            <OParagraph>{t('analytics_empty')}</OParagraph>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale = DEFAULT_LOCALE }) => ({
  props: {
    ...(await serverSideTranslations(locale || DEFAULT_LOCALE, ['common', 'analytics_services'])),
    backgroundColor: defaultColors.gray5,
  },
});

export default Services;
